module.exports = __webpack_public_path__ + "img/extended.c6c861b7.png";